/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import React from "react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ROLES from "../../../../../constants/roles";
import initCapitalize from "../../../../../utils/commonFunctions/initCapitalize";
import { RoleSelectionSignUpProps } from "../../../../../@types/components/signupV2.types";

import "./roleSelection.scss";

const RoleSelection = ({ handleClick, roleValidation, userRole, anchorEl, handleClose }: RoleSelectionSignUpProps) => {
	return (
		<div className="role-selection-main-container">
			<h3>Please select a Role</h3>
			<div className="select-role-container" id="select-role-container">
				<Button
					onClick={handleClick}
					endIcon={<ExpandMoreIcon style={{ color: "#9c27b0" }} />}
					style={{
						backgroundColor: "#e0e0e0",
						width: 200
					}}
				>
					{userRole !== "" ? userRole : "Select Your Role"}
				</Button>
				<Menu
					id="simple-menu"
					anchorEl={anchorEl}
					keepMounted
					open={Boolean(anchorEl)}
					onClose={() => handleClose(null)}
				>
					<MenuItem onClick={() => handleClose(initCapitalize(ROLES.admin))}>
						{initCapitalize(ROLES.admin)}
					</MenuItem>
					<MenuItem onClick={() => handleClose(initCapitalize(ROLES.employer))}>
						{initCapitalize(ROLES.employer)}
					</MenuItem>
					<MenuItem onClick={() => handleClose(initCapitalize(ROLES.employee))}>
						{initCapitalize(ROLES.employee)}
					</MenuItem>
					<MenuItem onClick={() => handleClose(initCapitalize(ROLES.dependent))}>
						{initCapitalize(ROLES.dependent)}
					</MenuItem>
				</Menu>
				{roleValidation ? (
					<div className="details" style={{ paddingLeft: "12" }}>
						<span className="select-validation-text">{roleValidation}</span>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default RoleSelection;
